var _linearGradient, _linearGradient2, _path, _linearGradient3, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_d41b56807d415be4383d0cabb485c3b512ec5c458f2a768625a8d7e00ae286d8",
    gradientUnits: "userSpaceOnUse",
    x1: -1591.535,
    y1: -484.509,
    x2: -1590.535,
    y2: -484.509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_d41b56807d415be4383d0cabb485c3b512ec5c458f2a768625a8d7e00ae286d8",
    gradientUnits: "userSpaceOnUse",
    x1: 68.837,
    y1: 132.388,
    x2: 141.396,
    y2: 132.388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_d41b56807d415be4383d0cabb485c3b512ec5c458f2a768625a8d7e00ae286d8)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M70.087 132.388h70.059"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_d41b56807d415be4383d0cabb485c3b512ec5c458f2a768625a8d7e00ae286d8",
    gradientUnits: "userSpaceOnUse",
    x1: -24.459,
    y1: 47.906,
    x2: 74.529,
    y2: 47.906,
    gradientTransform: "rotate(90 29.31 82.155)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_d41b56807d415be4383d0cabb485c3b512ec5c458f2a768625a8d7e00ae286d8)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M63.558 29.637v96.488"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M140.146 126.183V29.117H58.28l.057 102.73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M140.146 126.181H64.547c-3.416 0-6.211 2.795-6.211 6.211 0 3.416 2.795 6.211 6.211 6.211h75.598v-12.422z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M96.393 79.399h12.656v27.695H88.47V87.32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M110.275 84.239h4.221v28.352l-20.579.07v-5.232M96.393 79.399l-7.922 7.921h7.922z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M77.204 43.843h48.558v12.076H77.204zM85.469 61.179h32.029v6.038H85.469z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentJournal);
export default __webpack_public_path__ + "static/media/documentJournal.37429997dd0c858002062d1022a390af.svg";
export { ForwardRef as ReactComponent };